import React, { useCallback } from 'react';

import { List, Avatar } from 'antd';
import Button from '../button/button';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

interface Props {
	users?: Bringg.User[];
	onRemove?: (userId: number) => void;
	displayRemoveButton?: boolean;
	height: number;
	onUserClick?: (user: Bringg.User) => void;
}

const UserInfoList = ({ users, onRemove, displayRemoveButton, height, onUserClick }: Props) => {
	const handleUserClick = useCallback(
		user => () => {
			onUserClick(user);
		},
		[onUserClick]
	);

	const itemRenderer = useCallback(
		(user: Bringg.User) => {
			const { id, name, profile_image, phone } = user;
			const onClick = handleUserClick(user);

			return (
				<List.Item
					key={id}
					actions={
						displayRemoveButton
							? [
									<Button className="close-button" onClick={() => onRemove(id)} danger>
										<BringgIcon iconName={BringgFontIcons.Close} />
									</Button>
							  ]
							: []
					}
				>
					<List.Item.Meta
						avatar={<Avatar src={profile_image} />}
						title={
							<span className="clickable-span" onClick={onClick}>
								{name}
							</span>
						}
					/>
					<span className="phone-span">{phone}</span>
				</List.Item>
			);
		},
		[handleUserClick, displayRemoveButton, onRemove]
	);

	return (
		<List itemLayout="horizontal" style={{ height }} className="users-list-container">
			{users.map(user => itemRenderer(user))}
		</List>
	);
};

export default UserInfoList;
